import moment from 'moment'
import { ObjectifService } from '../services/ObjectifService'

export const state = {
  loading: false,
  objectifs: {},
  objectifsRange: {},
  dates: {},
  objectifsDetail: [],
  currentStock: {},
  lastMonthStock: {},
  week: {},
  month: {},
  cumulateCa: {},
  completeMonth: {},
  rangeEndStock: {},
  rangeStartStock: {},
}

export const mutations = {
  setObjectifsLoading(currentState, loading) {
    currentState.objectifs.loading = loading
  },
  setObjectifs(currentState, objectifs) {
    currentState.objectifs.objectifs = objectifs.objectifs
    currentState.objectifs.date = objectifs.date
  },
  setObjectifsRange(currentState, objectifs) {
    currentState.objectifs.objectifsRange = objectifs.objectifs
  },
  setRangeEndStock(currentState, currentStock) {
    currentState.objectifs.rangeEndStock = currentStock
  },
  setRangeStartStock(currentState, currentStock) {
    currentState.objectifs.rangeStartStock = currentStock
  },
  setObjectifsCompleteMonth(currentState, completeMonth) {
    currentState.objectifs.completeMonth = completeMonth
  },
  setObjectifWeek(currentState, week) {
    currentState.objectifs.week = week
  },
  setObjectifMonth(currentState, month) {
    currentState.objectifs.month = month
  },
  setObjectifCumulateCa(currentState, cumulateCa) {
    currentState.objectifs.cumulateCa = cumulateCa
  },
  setObjectifsDetailLoading(currentState, loading) {
    currentState.objectifs.loading = loading
  },
  setObjectifsDetail(currentState, objectifs) {
    currentState.objectifs.objectifsDetail = objectifs.objectifsDetail
    currentState.objectifs.date = objectifs.date
  },
  setCurrentStock(currentState, currentStock) {
    currentState.objectifs.currentStock = currentStock
  },
  setLastMonthStock(currentState, lastMonthStock) {
    currentState.objectifs.lastMonthStock = lastMonthStock
  },
}

export const actions = {
  setObjectifWeek({ commit }, week) {
    commit('setObjectifWeek', week)
  },
  setObjectifMonth({ commit }, month) {
    commit('setObjectifMonth', month)
  },
  setObjectifCumulateCa({ commit }, cumulateCa) {
    commit('setObjectifCumulateCa', cumulateCa)
  },
  setObjectifsCompleteMonth({ commit }, completeMonth) {
    commit('setObjectifsCompleteMonth', completeMonth)
  },
  setStock({ commit, rootState }, stock) {
    ObjectifService.setStock(rootState.authentication.userProfile.attributes.hublot_clientid[0], stock)
  },
  loadObjectifs({ commit, rootState }, dates) {
    commit('setObjectifsLoading', true)
    ObjectifService.getObjectif(rootState.authentication.userProfile.attributes.hublot_clientid[0], dates.dateStart, dates.dateEnd).then(objectifs => {
      commit('setObjectifsLoading', false)
      commit('setObjectifs', { objectifs, dateStart: dates.dateStart, dateEnd: dates.dateEnd })
    })
  },
  loadObjectifsRange({ commit, rootState }, params) {
    ObjectifService.getObjectif(rootState.authentication.userProfile.attributes.hublot_clientid[0], params.dateStart, params.dateEnd).then(objectifs => {
      commit('setObjectifsRange', { objectifs })
    })
     ObjectifService.getStock(rootState.authentication.userProfile.attributes.hublot_clientid[0], params.dateEnd).then(stockEst => {
      commit('setRangeEndStock', stockEst.final)
    })
     ObjectifService.getStock(rootState.authentication.userProfile.attributes.hublot_clientid[0], params.dateStart).then(stockEst => {
      commit('setRangeStartStock', stockEst.initial)
    })
  },
  loadObjectifsDetail({ commit, rootState }, dates) {
    commit('setObjectifsDetailLoading', true)
    ObjectifService.getObjectifDetail(rootState.authentication.userProfile.attributes.hublot_clientid[0], dates.dateStart, dates.dateEnd).then(objectifsDetail => {
      commit('setObjectifsDetailLoading', false)
      commit('setObjectifsDetail', { objectifsDetail, dateStart: dates.dateStart, dateEnd: dates.dateEnd })
    })
  },
  loadStock({ commit, rootState }, date) {
    ObjectifService.getStock(rootState.authentication.userProfile.attributes.hublot_clientid[0], moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')).then(stockEst => {
      commit('setCurrentStock', stockEst.final)
      commit('setLastMonthStock', stockEst.initial)
    })
  },
}
export default { state, actions, mutations }
